import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

export const useExtraDustyProducts = () => {
  const { extraDustyProductsStore } = useStore();

  useEffect(() => {
    extraDustyProductsStore.fetchExtraDustyProducts();
  }, []);

  return {
    isLoading: extraDustyProductsStore.isLoading,
    extraDustyProducts: extraDustyProductsStore.extraDustyProducts
  };
};
